module.exports = __webpack_public_path__ + "static/img/02-settings.9cf8a3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lti-setup-guide/02-settings.png
// module id = SvIg
// module chunks = 1